module.exports = __webpack_public_path__ + "static/media/dailymotion.278ebab2.svg";